import { useState, useEffect } from 'react';

export const useLazyImage = (src: string | undefined, visible = true) => {
  const [img, setImg] = useState('');

  useEffect(() => {
    if (!visible) {
      return;
    }

    const timeout = setTimeout(() => {
      if (src) {
        setImg(src);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src, visible]);

  return img;
};
